import Rest from "@/services/Rest";

export default class ProcedureTypeService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/procedureTypes'

}
